import React from 'react';
import SeoPageLayout from './SeoPageLayout';

const data = {
  slug: '/detection-explosifs-cynodex',
  themeColor: '#AC8631',
  metaTitle: 'Détection d\'Explosifs CYNODEX | Équipe Cynophile | MTJ Sécurité Privée',
  metaDescription: 'Unité CYNODEX spécialisée en détection d\'explosifs avec chiens entraînés. MTJ Sécurité Privée intervient à Toulon, Nice, Toulouse pour sécuriser événements et sites sensibles.',
  breadcrumbCurrent: 'CYNODEX - Détection d\'explosifs',
  areaServed: 'France entière',

  h1: 'CYNODEX — Détection d\'Explosifs par Équipe Cynophile',
  introduction: `L'unité CYNODEX de MTJ Sécurité Privée est spécialisée dans la détection d'explosifs à l'aide de chiens hautement entraînés. Face à la menace terroriste et aux risques liés aux engins explosifs improvisés, nos équipes certifiées apportent une capacité de détection inégalée par les technologies conventionnelles.\n\nCertifiée et habilitée, notre unité CYNODEX intervient pour sécuriser les événements de grande envergure, les sites sensibles et les lieux accueillant du public sur l'ensemble du territoire national.`,

  sections: [
    {
      h2: 'Missions de l\'unité CYNODEX',
      intro: 'L\'expertise CYNODEX de MTJ Sécurité Privée couvre l\'ensemble des besoins en détection d\'explosifs, de la prévention à l\'intervention d\'urgence.',
      subsections: [
        {
          h3: 'Levée de doute et inspection de sites',
          content: 'Nos équipes CYNODEX effectuent des levées de doute sur les colis ou objets suspects identifiés dans vos locaux ou sur vos sites. Le chien de détection d\'explosifs, grâce à son flair exceptionnel, est capable d\'identifier des traces infimes de matières explosives, même dissimulées. Cette prestation est essentielle pour les sièges d\'entreprises, les administrations, les ambassades et les lieux de pouvoir.',
          list: ['Levée de doute sur colis suspects', 'Inspection de véhicules', 'Vérification de locaux avant occupation', 'Recherche de matières explosives']
        },
        {
          h3: 'Sécurisation pré-événementielle',
          content: 'Avant chaque événement majeur (concert, match sportif, congrès, sommet diplomatique), nos équipes CYNODEX procèdent à une inspection complète des lieux. Le chien détecteur balaye l\'ensemble de l\'enceinte, des coulisses, des zones techniques et des parkings pour garantir l\'absence de toute menace explosive. Cette prestation s\'inscrit dans une démarche globale de sûreté événementielle.'
        }
      ]
    },
    {
      h2: 'Compétences et habilitations CYNODEX',
      intro: 'La détection d\'explosifs exige un niveau de certification et d\'entraînement supérieur aux missions de sécurité cynophile classiques.',
      subsections: [
        {
          h3: 'Certification spécialisée détection d\'explosifs',
          content: 'Nos maîtres-chiens CYNODEX sont titulaires de certifications spécifiques en détection d\'explosifs, en complément de leur carte professionnelle CNAPS. Cette qualification atteste de leur capacité à identifier l\'ensemble des familles d\'explosifs (militaires, commerciaux, artisanaux) et à opérer selon des protocoles stricts de sécurité.'
        },
        {
          h3: 'Chiens détecteurs : entraînement spécialisé',
          content: 'Les chiens de notre unité CYNODEX suivent un programme d\'entraînement intensif et continu à la détection de matières explosives. Ils sont capables de détecter plus de 20 familles d\'explosifs différentes. Leur entraînement est supervisé par des spécialistes et fait l\'objet d\'évaluations régulières pour garantir un taux de détection optimal.'
        },
        {
          h3: 'Coordination avec les forces de l\'ordre',
          content: 'En cas de détection positive, nos équipes CYNODEX appliquent des protocoles d\'alerte stricts et assurent la liaison avec les forces de sécurité intérieure (police, gendarmerie, démineurs). Notre professionnalisme et notre rigueur en font un partenaire de confiance des autorités dans la chaîne de sécurité nationale.'
        }
      ]
    },
    {
      h2: 'Applications et secteurs d\'intervention',
      subsections: [
        {
          h3: 'Événements de grande envergure',
          content: 'Festivals, concerts, compétitions internationales, sommets politiques : notre unité CYNODEX sécurise les événements accueillant des milliers de personnes. Nous intervenons en amont de l\'événement pour l\'inspection des lieux et pendant la manifestation pour assurer une veille permanente.',
          list: ['Festivals et concerts', 'Événements sportifs internationaux', 'Congrès et salons professionnels', 'Cérémonies officielles']
        },
        {
          h3: 'Sites sensibles et infrastructures critiques',
          content: 'Nos équipes CYNODEX protègent les infrastructures critiques : centres commerciaux, gares, aéroports, sites militaires, installations nucléaires et bâtiments gouvernementaux. La détection canine offre une couche de sécurité complémentaire aux dispositifs technologiques existants (portiques, scanners, caméras).'
        }
      ]
    }
  ],

  faq: [
    {
      question: 'Qu\'est-ce que le CYNODEX exactement ?',
      answer: 'CYNODEX signifie "Cynophile Détection d\'Explosifs". C\'est une spécialisation de la sécurité cynophile dédiée à la détection de matières explosives à l\'aide de chiens spécialement entraînés. Les équipes CYNODEX interviennent pour sécuriser des sites et des événements en identifiant la présence potentielle d\'engins explosifs.'
    },
    {
      question: 'Le chien peut-il détecter tous les types d\'explosifs ?',
      answer: 'Nos chiens CYNODEX sont entraînés à détecter plus de 20 familles d\'explosifs, incluant les explosifs militaires (C4, TNT, Semtex), commerciaux (dynamite, détonateurs) et artisanaux (TATP, peroxydes). Leur entraînement est continuellement mis à jour pour intégrer les nouvelles menaces identifiées.'
    },
    {
      question: 'Dans quels délais pouvez-vous intervenir ?',
      answer: 'MTJ Sécurité Privée peut mobiliser son unité CYNODEX sous 24 à 48 heures pour les missions planifiées. En cas d\'urgence ou de levée de doute immédiate, nous disposons d\'une capacité d\'intervention rapide dans la zone PACA et le sud de la France. Contactez-nous au 07 60 73 82 06 pour évaluer votre besoin.'
    }
  ],

  conclusion: `La détection d'explosifs par unité cynophile représente l'un des moyens les plus fiables et les plus efficaces pour sécuriser vos sites et vos événements face à la menace terroriste. L'unité CYNODEX de MTJ Sécurité Privée vous offre cette expertise de pointe, soutenue par des équipes certifiées et des chiens entraînés aux standards les plus élevés.\n\nProtégez vos collaborateurs, vos clients et votre public avec une solution de détection éprouvée. Contactez MTJ Sécurité Privée pour un devis adapté à votre situation.`,

  relatedLinks: [
    { href: '/securite-cynophile-maitre-chien', label: 'Sécurité cynophile et maître-chien' },
    { href: '/securite-evenementielle', label: 'Sécurité événementielle' },
    { href: '/agent-securite-prevention', label: 'Agent de prévention et sécurité' },
    { href: '/securite-privee-toulon', label: 'Sécurité privée à Toulon' },
    { href: '/securite-privee-nice-monaco', label: 'Sécurité privée Nice & Monaco' },
    { href: '/securite-privee-toulouse', label: 'Sécurité privée à Toulouse' },
  ]
};

export default function CynodexPage() {
  return <SeoPageLayout data={data} />;
}
